import React, { Component } from "react";
import "../css/favorite.css";
import { FaTimesCircle } from 'react-icons/fa';
import PlanPage from "./PlanPage";
import BuyOptions from "./BuyOptions";
import Modal from 'react-modal';

class Favorite extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hidden: false,
            openPlanPage: false,
            currentPageOffset: 0,
            buyOptionsModalIsOpen: false
        }
    }

    render() {

        const planId = this.props.item.planId;
        const bedrooms = this.props.item.bedrooms;
        const bathrooms = this.props.item.bathrooms;
        const total_sqft = this.props.item.total_sqft;
        const levels = this.props.item.levels;
        const image = this.props.item.main_image;

        var hidden = {};
        if (this.state.hidden == true) {
            hidden = { height: "0px", opacity: 0, marginTop: "0px" };
        }

        var planLink = "/webapp/plan/?planId=" + planId;

        return (
            <div>
                {this.renderPlanPage()}
                <div style={hidden} className="favoriteHolder">

                    {this.renderRemoveButton()}

                    <div onClick={() => { this.setState({ openPlanPage: true }) }} className="row1">
                        <img className="mainImage" src={"https://www.houseplanstore.com/media/" + image} />
                        <div className="planInfo">
                            <span className="favoritePlanId">{planId}</span><br />
                            <span className="text">Levels: <strong>{levels}</strong></span><br />
                            <span className="text">Bedrooms: <strong>{bedrooms}</strong></span><br />
                            <span className="text">Bathrooms: <strong>{bathrooms}</strong></span><br />
                            <span className="text">Sqft: <strong>{total_sqft}</strong></span>
                        </div>
                    </div>

                    <div className="row2">
                        {/* <div className="detailsButton">Details</div> */}
                        <div onClick={() => { this.openBuyOptionsModal() }} className="addToCartButton">Purchase</div>
                    </div>

                    <Modal
                        isOpen={this.state.buyOptionsModalIsOpen}
                        ariaHideApp={false}
                        //onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeBuyOptionsModal}
                        style={{ overlay: { backgroundColor: "rgba(0, 0, 0, 0.6)" }, content: { zIndex: 9999 } }}
                        contentLabel="Buy"
                    >
                        <BuyOptions planId={planId} />
                    </Modal>


                </div>
            </div>
        );
    }

    updateFunction = () => {
        this.setState({ openPlanPage: !this.state.openPlanPage });
    }


    renderPlanPage = () => {
        if (this.state.openPlanPage == true) {
            return (
                <PlanPage updateFunction={this.updateFunction} planId={this.props.item.planId} />
            );
        }
    }

    openBuyOptionsModal = () => {
        this.setState({ buyOptionsModalIsOpen: true });
    }

    closeBuyOptionsModal = () => {
        this.setState({ buyOptionsModalIsOpen: false });
    }

    scrollToTopFunction = () => { this.myRef.scrollTop = 0; }


    renderRemoveButton = () => {
        if (this.props.type !== "linkList") {
            return (
                <div onClick={() => { this.removeFavorite() }} className="removeFavorite"><FaTimesCircle /></div>
            )
        }
    }

    removeFavorite = () => {
        var favorites = localStorage.getItem('favorites');
        favorites = favorites.replace(this.props.item.planId + ",", "");
        localStorage.setItem('favorites', favorites);
        this.setState({ hidden: true });
    }

    closePlanPage = () => {
        this.setState({ openPlanPage: false });
    }

    componentDidMount() {

    }



}

export default Favorite;